import React from 'react';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="relative pt-10 pb-10 md:pt-16 md:pb-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-93">
      <FadeIn data-id="element-94">
        <div className="w-full max-w-md mx-auto mb-6 md:mb-8 rounded-2xl overflow-hidden shadow-2xl shadow-amber-500/10 border border-white/10" data-id="element-95">
          <img src="https://cdn.magicpatterns.com/uploads/1kq3T6XPfwQS9khNLoJzZ8/heylloyd-image-1776548446454.png" alt="La Parálisis del Todo o Nada" className="w-full h-auto object-cover" data-id="element-96" />
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-97">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4 tracking-tight" data-id="element-98">
          Tu cerebro no tiene un problema de voluntad, tiene un{' '}
          <span className="text-amber-500" data-id="element-99">
            cortocircuito en el motor de arranque.
          </span>
        </h1>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-100">
        <p className="text-base md:text-lg text-slate-300 max-w-2xl mx-auto mb-6 leading-relaxed" data-id="element-101">
          Deja de culpar a la pereza: el método de Micro-Inercia para vencer la
          parálisis TDAH y terminar lo que empezaste sin quemar tu energía
          mental.
        </p>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-102">
        <button onClick={() => document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      })} className="inline-flex bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold text-lg md:text-xl py-4 px-8 md:px-12 rounded-full transition-all duration-300 transform hover:scale-105 shadow-[0_0_20px_rgba(245,158,11,0.4)] cursor-pointer" data-id="element-103">
          QUIERO SALIR DE LA PARÁLISIS AHORA
        </button>
      </FadeIn>
    </section>;
}